import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      icon: 'fas fa-user-tie',
      title: 'Executive Search',
      description: 'Identifying, attracting, and placing top-tier leadership talent to drive organizational success.',
      link: '/executive-search'
    },
    {
      icon: 'fas fa-laptop-code',
      title: 'Tech Recruitment',
      description: 'Specialized recruitment services for global tech companies, ensuring you get the right talent in a highly competitive market.',
      link: '/tech-recruitment'
    },
    {
      icon: 'fas fa-users-cog',
      title: 'Recruitment Process Outsourcing (RPO)',
      description: 'Outsource your complete recruitment process to our dedicated experts, ensuring efficiency, speed, and quality hiring.',
      link: '/rpo'
    },
    {
      icon: 'fas fa-hard-hat',
      title: 'Labour Contractor & Manpower Supplier',
      description: 'Supplying skilled and unskilled labor locally and internationally with reliable workforce management solutions.',
      link: '/labour-contractor'
    },
    {
      icon: 'fas fa-calculator',
      title: 'Payroll Outsourcing',
      description: 'Streamline payroll with our AI-powered Cloud-based HRMS, ensuring compliance, accuracy, and efficiency.',
      link: '/payroll-outsourcing'
    },
    {
      icon: 'fas fa-rocket',
      title: 'Start-up Growth Consultancy',
      description: 'End-to-end consulting for startups and scale-ups, helping businesses innovate, grow, and expand globally.',
      link: '/startup-growth-consultancy'
    },
    {
      icon: 'fas fa-sitemap',
      title: 'OD & Management Consultancy',
      description: 'Organizational development and management consulting to optimize culture, structure, and processes for sustainable growth.',
      link: '/od-consultancy'
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Performance Management',
      description: 'Customized frameworks and tools to track, enhance, and reward employee performance, driving long-term success.',
      link: '/performance-management'
    },
    {
      icon: 'fas fa-clipboard-list',
      title: 'HR Policy Management',
      description: 'Designing and implementing HR policies that ensure compliance, fairness, and employee engagement.',
      link: '/hr-policy-management'
    },
    {
      icon: 'fas fa-graduation-cap',
      title: 'Specialized Training Solutions',
      description: 'Tailored training programs for workforce development, leadership, compliance, and future-ready skills.',
      link: '/specialized-training-solutions'
    },
    {
      icon: 'fas fa-lightbulb',
      title: 'Startup Consultancy',
      description: 'Guiding entrepreneurs and businesses from idea stage to execution with mentorship, funding strategies, and HR solutions.',
      link: '/startup-consultancy'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>Our Services</h2>
          <p>Comprehensive HR solutions tailored to your business needs</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              className={`service-card ${
                service.title === 'Specialized Training Solutions' 
                  ? 'service-card-orange' 
                  : index % 2 === 0 
                    ? 'service-card-white' 
                    : 'service-card-black'
              }`}
              onClick={() => navigate(service.link)}
              style={{ cursor: 'pointer' }}
            >
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
